"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _recharts = require("recharts");

var _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var XAxis = (0, _mobxReact.observer)(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(XAxis, _Component);

  var _super = _createSuper(XAxis);

  function XAxis() {
    (0, _classCallCheck2["default"])(this, XAxis);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(XAxis, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_recharts.XAxis, this.props);
    }
  }]);
  return XAxis;
}(_react.Component), _class2.propDoc = {
  dataKey: {
    required: true,
    type: "string | number",
    description: "The key of data displayed in the axis."
  },
  axisLine: {
    required: false,
    type: "boolean",
    description: "If set false, no axis line will be drawn."
  },
  tickLine: {
    required: false,
    type: "boolean",
    description: "If set false, no axis tick lines will be drawn."
  },
  fontFamily: {
    required: false,
    type: "string",
    description: "font of x axis labels"
  },
  fontSize: {
    required: false,
    type: "string",
    description: "font size of x axis labels"
  },
  fontWeight: {
    required: false,
    type: "string",
    description: "font weight of x axis labels"
  }
}, _class2.defaultProps = {
  axisLine: false,
  tickLine: false,
  dy: 15,
  fontSize: "12"
}, _temp)) || _class;

var _default = XAxis;
exports["default"] = _default;